require('../fhApp/currentUser/currentUser');
require('./plans/plansService');
require('../fhApp/productService');
require('../fhApp/serviceBreakerService');

"use strict";

angular.module('app.pricing.pricingController', [
  'app.currentUser',
  'app.pricing.plans.plansService',
  'app.appMetaService',
  'app.productService',
  'app.serviceBreakerService',
])
  .controller('app.pricing.pricingController', [
    '$scope', 'currentUser', '$state', 'app.pricing.plans.plansService', 'app.productService', 'PRODUCT', 'app.serviceBreakerService', '$timeout',
    function ($scope, currentUser, $state, pricingPlans, productService, PRODUCT, serviceBreakerService, $timeout) {
      $scope.currentUser = currentUser;
      $scope.pricingPlans = pricingPlans;
      $scope.displayTeamSubscriptions = productService.useTeamSubscriptions();
      $scope.allAccessPlans = [];
      $scope.teamPlans = [];
      $scope.breakers = serviceBreakerService.breakers;
      $scope.groupedPlans = { commonPlanAttrs: {}, plans: [] };
      let timer;

      let init = function () {
        if (!currentUser.is_logged_in()) {
          $state.current.noTopControls = true;
          $state.current.noSidebar = true;
        } else {
          $state.current.noTopControls = false;
          $state.current.noSidebar = false;
        }

        currentUser.get_current_subscriptions('recurly').then(() => {
          currentUser.get_invalid_conversions().then(() => {
            pricingPlans.retrieve(null, { sort: 'active' }).then(() => {
              if (pricingPlans.list) {
                switch (PRODUCT.Code) {
                  case 'ahl':
                    // sort the plans by price from highest to lowest
                    pricingPlans.list.sort((a, b) => (a.total_price < b.total_price) ? 1 : ((b.total_price < a.total_price) ? -1 : 0));

                    _.forEach(pricingPlans.list, (plan) => {
                      let invalidConversion = false;
                      let invalidConversionPlanId = null;

                      // If the user already is subscribed to the plan, don't include it
                      let userSubscribedToPlan = _.filter(currentUser.subscriptions.recurly, function (rs) { return rs.plan_id == plan.id; }).length > 0;

                      // Check against the users subscriptions and invalid conversions
                      let planInvalidConversions = _.filter(currentUser.subscriptions.invalidConversions, function (ics) { return ics.to_psp_id == plan.product_subscription_plan_id; });
                      // Loop through the invalid conversions and check if the user is subscribed to the *from* plans
                      _.forEach(planInvalidConversions, (ic) => {
                        // There is always a from plan 1
                        let fp1Sub = _.filter(currentUser.subscriptions.recurly, function (rs) { return rs.plan.product_subscription_plan_id == ic.from_psp_id_1; });
                        // If user is subscribed to first from...
                        if (fp1Sub.length > 0) {
                          // If there is a second plan, check if the user is subscribed to that plan
                          if (ic.from_psp_id_2) {
                            let fp2Sub = _.filter(currentUser.subscriptions.recurly, function (rs) { return rs.plan.product_subscription_plan_id == ic.from_psp_id_2; });
                            if (fp2Sub.length > 0) {
                              invalidConversion = true;
                              invalidConversionPlanId = ic.to_psp_id;
                            }
                          }
                          else {
                            invalidConversion = true;
                            invalidConversionPlanId = ic.to_psp_id;
                          }
                        }
                      });

                      switch (plan.type) {
                        case 'team_home':
                        case 'team_away':
                          if (_.isEmpty($scope.groupedPlans.commonPlanAttrs)) {
                            $scope.groupedPlans.commonPlanAttrs = {
                              name: 'Home OR Away Single Team Pass',
                              description: plan.description,
                              total_price: plan.total_price,
                              currency_symbol: plan.currency_symbol,
                            };
                          }
                          if (!userSubscribedToPlan && !invalidConversion) {
                            $scope.groupedPlans.plans.push((plan));
                          }
                          break;
                        case 'global':
                        case 'league':
                          if (!userSubscribedToPlan && !invalidConversion) {
                            $scope.allAccessPlans.push(plan);
                          }
                          else if (invalidConversion) {
                            // With an invalid conversion, remove the plan in case it has already been added
                            $scope.allAccessPlans = $scope.allAccessPlans.filter(obj => obj.product_subscription_plan_id !== invalidConversionPlanId);
                          }
                          break;
                        case 'team_all':
                        case 'team_home':
                        case 'team_away':
                          if (!userSubscribedToPlan && !invalidConversion) {
                            $scope.teamPlans.push(plan);
                          }
                          else if (invalidConversion) {
                            // With an invalid conversion, remove the plan in case it has already been added
                            $scope.teamPlans = $scope.teamPlans.filter(obj => obj.product_subscription_plan_id !== invalidConversionPlanId);
                          }
                          break;
                      }
                    });

                    // The below shouldn't do anything in theory, but without it there were cases where the UI would not update and
                    // would show blank rather than the available plans
                    $scope.allAccessPlans = _.filter($scope.allAccessPlans, function (plan) { return plan.type === 'global' || plan.type === 'league'; });
                    $scope.teamPlans = _.filter($scope.teamPlans, function (plan) { return plan.type === 'team_all' || plan.type === 'team_home' || plan.type === 'team_away'; });
                    break;
                  case 'htv':
                    $scope.allAccessPlans = _.filter(pricingPlans.list, function (plan) { return plan.type === 'global'; });
                }
              }
            });
          });
        });

        checkBreaker();
      };

      let checkBreaker = () => {
        serviceBreakerService.checkRecurly()
          .then(() => {
            timer = $timeout(
              () => {
                checkBreaker();
              },
              60000
            );
          });
      };

      $scope.hasSubscription = () => {
        return currentUser.subscriptions.recurly && currentUser.subscriptions.recurly.length > 0;
      };

      $scope.$on('$destroy', function () {
        $timeout.cancel(timer);
      });

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/pricing/pricingController.js